import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
  getPrintersList(params) {
    return Axios.post(`${baseURL}record/printer/list`, params)
      .then(res => res.data?.response?.resources || []);
  }
};
